import { render, staticRenderFns } from "./foodCourtForm.vue?vue&type=template&id=ca274bb2&scoped=true&lang=en&"
import script from "./foodCourtForm.vue?vue&type=script&lang=js&"
export * from "./foodCourtForm.vue?vue&type=script&lang=js&"
import style0 from "./foodCourtForm.vue?vue&type=style&index=0&id=ca274bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca274bb2",
  null
  
)

export default component.exports